import React from 'react';
import Hero from '../sections/Hero';
import CoreValues from '../sections/CoreValues';
import Advantages from '../sections/Advantages';
import Pricing from '../sections/Pricing';
import Contact from '../sections/Contact';
import Blog from '../sections/Blog';
import SisterServices from '../sections/SisterServices';

const Home: React.FC = () => {
  const showSisterServices = import.meta.env.VITE_SHOW_SISTER_SERVICES === 'true';

  return (
    <>
      <Hero />
      <Advantages />
      <CoreValues />
      <Pricing />
      <Blog />
      {showSisterServices && <SisterServices />}
      <Contact />
    </>
  );
};

export default Home;